{
  "DATA_ASSISTANT": {
    "TITLE": "Gagnaaðstoð",
    "NEW_CONVERSATION": "+ Nýtt",
    "LOADING": "Hleð...",
    "LOADING_MESSAGES": "Hleð skilaboðum...",
    "THINKING": "Hugsar...",
    "UNTITLED": "Ónefnt samtal",
    "NO_CONVERSATIONS": "Engin samtöl ennþá. Smelltu á „+ Nýtt“ til að byrja.",
    "EMPTY_STATE": "Veldu samtal eða stofnaðu nýtt til að byrja.",
    "PLACEHOLDER": "Hvað get ég komist að fyrir þig?",
    "SHOW_SQL": "Sýna SQL",
    "NO_ROWS": "Engar raðir fundust.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Eyða samtali",
    "DELETE_CONFIRM_DESCRIPTION": "Ertu viss um að þú viljir eyða þessu samtali? Ekki er hægt að afturkalla þessa aðgerð.",
    "DELETE_CONFIRM_YES": "Eyða",
    "REPORTS": "Skýrslur",
    "SAVE_TO_REPORT": "Vista í skýrslu",
    "NEW_REPORT": "Ný skýrsla",
    "REPORT_NAME": "Nafn skýrslu",
    "NO_REPORTS": "Engar vistaðar skýrslur ennþá",
    "REPORTS_EMPTY_STATE": "Veldu skýrslu eða stofnaðu nýja.",
    "REPORT_SAVED": "Vistað í skýrslu",
    "DELETE_REPORT_CONFIRM": "Eyða skýrslu",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Ertu viss um að þú viljir eyða þessari skýrslu? Öll vistuð atriði verða fjarlægð.",
    "DELETE_ITEM_CONFIRM": "Fjarlægja atriði",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Ertu viss um að þú viljir fjarlægja þetta atriði úr skýrslunni?",
    "EXPORT_CSV": "Flytja út CSV",
    "REFRESH": "Uppfæra",
    "QUERY_RUNNING": "Keyri fyrirspurn...",
    "QUERY_FAILED": "Fyrirspurn mistókst",
    "AUTO_REFRESH": "Sjálfvirk uppfærsla",
    "AUTO_REFRESH_NONE": "Handvirkt",
    "AUTO_REFRESH_30S": "30 sekúndur",
    "AUTO_REFRESH_1M": "1 mínúta",
    "AUTO_REFRESH_5M": "5 mínútur",
    "AUTO_REFRESH_10M": "10 mínútur",
    "EDIT_MESSAGE": "Breyta skilaboðum",
    "RENAME_REPORT": "Endurnefna skýrslu",
    "RENAME_ITEM": "Endurnefna atriði",
    "MOVE_UP": "Færa upp",
    "MOVE_DOWN": "Færa niður",
    "COLLABORATORS": {
      "BUTTON": "Samstarfsaðilar",
      "TITLE": "Samstarfsaðilar skýrslu",
      "DESCRIPTION": "Veldu hvaða þjónustufulltrúar og teymi geta skoðað þessa skýrslu.",
      "AGENTS": "Þjónustufulltrúar",
      "TEAMS": "Teymi",
      "SELECT_AGENTS": "Veldu þjónustufulltrúa",
      "SELECT_TEAMS": "Veldu teymi",
      "SAVE": "Vista",
      "SAVED": "Samstarfsaðilar uppfærðir",
      "SAVE_FAILED": "Ekki tókst að uppfæra samstarfsaðila"
    }
  }
}
